var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[_c('Nav-bar'),_c('transition',{attrs:{"name":"router-anim"}},[_c('router-view')],1),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }